import { Modal } from "antd";
import validadeCPF from "../../../../components/Validators/CPF";
import validadeCNPJ from "../../../../components/Validators/CNPJ";

/**
 * Valida os dados informados no filtro verde
 * @param {Object} data - Informações do formulário
 * @param {Object} pasta - Informações da pasta
 */
const validateVerdeData = (data, pasta) => {
  // Placa
  if (data.possui_placa == "1") {
    if (data.placa == null || data.placa == "" || data.placa.lenght == 0) {
      Modal.error({
        title: "Erro",
        content: "Informe a placa do 3º!"
      });
      return false;
    } else {
      /** Compara a placa informada com a placa do segurado */
      if (pasta.veiculo.placa != null) {
        if (pasta.veiculo.placa == data.placa) {
          Modal.error({
            title: "Erro",
            content: "A placa do 3º não pode ser a mesma do segurado!"
          });
          return false;
        }
      }
    }
  }

  // Cpf/cnpj
  if (data.condutor_cpf_cnpj == null && data.proprietario_cpf_cnpj == null) {
    Modal.error({
      title: "Erro",
      content: "Informe ao menos o CPF/CNPJ do proprietário ou do condutor."
    });
    return false;
  }

  if (data.condutor_cpf_cnpj != null && data.proprietario_cpf_cnpj != null) {
    if (
      (data.condutor_cpf_cnpj + "").length > 0 &&
      (data.proprietario_cpf_cnpj + "").length > 0
    ) {
      if (data.condutor_cpf_cnpj == data.proprietario_cpf_cnpj) {
        Modal.error({
          title: "Erro",
          content:
            "O CPF/CNPJ do condutor não pode ser o mesmo do proprietário."
        });
        return false;
      }
    }
  }

  /** CPF sem formatação */
  const clean_cond_cpf = data.condutor_cpf_cnpj
    ? (data.condutor_cpf_cnpj + "").replace(/[^0-9]/g, "")
    : "";

  const clean_prop_cpf = data.proprietario_cpf_cnpj
    ? (data.proprietario_cpf_cnpj + "").replace(/[^0-9]/g, "")
    : "";

  if (clean_cond_cpf.length > 0) {
    if (clean_cond_cpf == pasta.segurado.cpf_cnpj) {
      Modal.error({
        title: "Erro",
        content: "O CPF/CNPJ do condutor não pode ser o mesmo do segurado."
      });
      return false;
    }
    /** Bloqueia o CNPJ da HDI */
    if (clean_cond_cpf == "29980158000157") {
      Modal.error({
        title: "Erro",
        content: "O CPF/CNPJ do condutor é inválido."
      });
      return false;
    }
    /** Valida o cpf */
    if (clean_cond_cpf.length <= 11) {
      if (!validadeCPF(clean_cond_cpf)) {
        Modal.error({
          title: "Erro",
          content: "O CPF do condutor é inválido."
        });
        return false;
      }
    }
    /** Valida o cnpj */
    if (clean_cond_cpf.length > 11) {
      if (!validadeCNPJ(clean_cond_cpf)) {
        Modal.error({
          title: "Erro",
          content: "O CNPJ do condutor é inválido."
        });
        return false;
      }
    }
  }

  if (clean_prop_cpf.length > 0) {
    if (clean_prop_cpf == pasta.segurado.cpf_cnpj) {
      Modal.error({
        title: "Erro",
        content: "O CPF/CNPJ do proprietário não pode ser o mesmo do segurado."
      });
      return false;
    }
    /** HDI cnpj check */
    if (clean_prop_cpf == "29980158000157") {
      Modal.error({
        title: "Erro",
        content: "O CPF/CNPJ do proprietário é inválido."
      });
      return false;
    }
    /** Valida o cpf */
    if (clean_prop_cpf.length <= 11) {
      if (!validadeCPF(clean_prop_cpf)) {
        Modal.error({
          title: "Erro",
          content: "O CPF do proprietário é inválido."
        });
        return false;
      }
    }
    /** Valida o cnpj */
    if (clean_prop_cpf.length > 11) {
      if (!validadeCNPJ(clean_prop_cpf)) {
        Modal.error({
          title: "Erro",
          content: "O CNPJ do proprietário é inválido."
        });
        return false;
      }
    }
  }

  return true;
};

export default validateVerdeData;



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/Verde/Validator.js